import { S27 } from '#src/atoms/icons/S27.tsx';
import { SorareLogo } from '#src/atoms/icons/SorareLogo/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import type { Color, HexColorOnly } from '#src/style/types.ts';

type Size = 'small' | 'medium' | 'large';

const SIZE_CONFIG = {
  small: { gap: 1, iconSize: 4 },
  medium: { gap: 2, iconSize: 7 },
  large: { gap: 2, iconSize: 8 },
} as const;

type Props = {
  size?: Size;
  color?: Color | HexColorOnly;
};

export const NewSeasonLogo = ({
  size = 'medium',
  color = 'var(--c-white)',
}: Props) => {
  const { gap, iconSize } = SIZE_CONFIG[size];

  return (
    <Horizontal gap={gap}>
      <SorareLogo size={size} color={color} />
      <S27 size={iconSize} color={color} />
    </Horizontal>
  );
};
